import BasePageView from "components/core/BasePageView/BasePageView";
import useAllDDPoViewLogic from "./useAllDDPoViewLogic";
import AllDDPoViewDesktop from "./AllDDPoViewDesktop";
import AllDDPoViewMobile from "./AllDDPoViewMobile";
import useSellerContext from "hooks/useSellerContext";

const AllDDPoView = () => {
  const vm = useAllDDPoViewLogic();
  const { currentSellerDetail, allSellersDetails, handleProfileNavigate } = useSellerContext();

  return (
    <BasePageView
      DesktopView={AllDDPoViewDesktop}
      MobileView={AllDDPoViewMobile}
      viewProps={vm}
      headerProps={{
        showSubHeader: true,
        sellerDetail: currentSellerDetail,
        allSellerDetails: allSellersDetails,
        handleProfile: handleProfileNavigate,
      }}
    />
  );
};

export default AllDDPoView;
